export const getWsUrl = (token: string) => {
  const baseURI = import.meta.env.VITE_WEBSOCKET_URI;
  return `${baseURI}?token=${token}`;
};
